package shared.ui

import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import features.teams.ui.modals.*
import features.members.ui.modals.*
import features.shifts.ui.modals.*
import features.schedule.ui.modals.*
import features.timeoff.ui.modals.*
import features.overtime.ui.modals.*
import features.attendance.ui.modals.*
import features.notifications.ui.modals.*

object ModalManager {
    private var currentModal: HTMLElement? = null
    
    fun show(modalId: String) {
        val overlay = document.getElementById("modal-overlay") as? HTMLElement
        if (overlay == null) {
            console.log("Modal overlay not found!")
            return
        }
        overlay.classList.remove("hidden")
        overlay.style.removeProperty("display")
        overlay.style.setProperty("pointer-events", "auto")
        
        // Re-render notification modal to get fresh data
        if (modalId == "notification-list-modal") {
            val modalContainer = document.getElementById(modalId) as? HTMLElement
            if (modalContainer != null) {
                // Clear and re-render
                modalContainer.innerHTML = ""
                val parent = modalContainer.parentElement
                if (parent != null) {
                    modalContainer.remove()
                    NotificationListModal.render(parent as HTMLElement)
                }
            }
        }
        
        val modal = document.getElementById(modalId) as? HTMLElement
        if (modal == null) {
            console.log("Modal element with ID $modalId not found!")
            return
        }
        modal.classList.remove("hidden", "opacity-0", "scale-95")
        currentModal = modal
        console.log("Showing modal: $modalId")
    }
    
    fun close() {
        val overlay = document.getElementById("modal-overlay") as? HTMLElement
        overlay?.classList?.add("opacity-0")
        
        currentModal?.classList?.add("opacity-0", "scale-95")
        
        kotlinx.browser.window.setTimeout({
            overlay?.classList?.add("hidden")
            overlay?.style?.setProperty("display", "none")
            overlay?.style?.setProperty("pointer-events", "none")
            
            currentModal?.classList?.add("hidden")
            currentModal = null
            console.log("Modal closed")
        }, 300)
    }
    
    fun setupModalOverlay(root: HTMLElement) {
        root.append {
            div("fixed inset-0 bg-black/50 backdrop-blur-sm z-[100] hidden opacity-0 transition-opacity duration-300") {
                id = "modal-overlay"
                onClickFunction = { close() }
            }
        }
        
        // Render all modals
        CreateTeamModal.render(root)
        EditTeamNameModal.render(root)
        EditTeamAvatarModal.render(root)
        
        AddMemberModal.render(root)
        EditMemberModal.render(root)
        ImportExportModal.render(root)
        BulkEditRoleModal.render(root)
        BulkDeleteModal.render(root)
        
        CreateShiftModal.render(root)
        EditShiftModal.render(root)
        AssignShiftModal.render(root)
        
        EditScheduleModal.render(root)
        
        RequestTimeOffModal.render(root)
        ManageCategoriesModal.render(root)
        
        RequestOvertimeModal.render(root)
        
        ClockInModal.render(root)
        ManageHolidaysModal.render(root)
        
        // Notification modal
        NotificationListModal.render(root)
    }
}
